import { render, staticRenderFns } from "./MainHeaderContainer.vue?vue&type=template&id=becd6cb6&scoped=true&lang=pug&"
import script from "./MainHeaderContainer.vue?vue&type=script&lang=js&"
export * from "./MainHeaderContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainHeaderContainer.vue?vue&type=style&index=0&id=becd6cb6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becd6cb6",
  null
  
)

export default component.exports